import { Base } from "ui/Scripts/source/framework/base";
import { TaskStateEditabilityType } from "ui/Scripts/source/models/enums";

export interface ITaskStateListItem {
    id: string;
    companyId: string;
    taskTypeId: string;
    code: string;
    color: string;
    comment: string;
    sortOrder: number;
    editabilityType: TaskStateEditabilityType;
    activeState: number;
}

export class TaskStateListItem implements ITaskStateListItem {
    id: string;
    companyId: string;
    taskTypeId: string;
    code: string;
    color: string;
    comment: string;
    sortOrder: number;
    editabilityType: TaskStateEditabilityType;
    activeState: number;

    constructor();
    constructor(obj: ITaskStateListItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.companyId = obj && obj.companyId || "";
        this.taskTypeId = obj && obj.taskTypeId || "";
        this.code = obj && obj.code || "";
        this.color = obj && obj.color || "";
        this.comment = obj && obj.comment || "";
        this.sortOrder = obj && obj.sortOrder || 0;
        this.editabilityType = obj && obj.editabilityType || TaskStateEditabilityType.NoLimitation;
        this.activeState = obj && obj.activeState || 0;
    }

    static sortTaskStateListItems(items: TaskStateListItem[]): TaskStateListItem[] {
        if (!items && items.length < 2) return items;
        return items.sort((a: TaskStateListItem, b: TaskStateListItem) => {
            if (!a || !b) return 0;
            let result = Base.numCompare(a.activeState, b.activeState);
            if (result !== 0) return result;
            result = Base.numCompare(a.sortOrder, b.sortOrder);
            if (result !== 0) return result;
            return Base.strCompare(a.code, b.code);
        });
    }
}